module.exports = __webpack_public_path__ + "assets/img/ios-landscape.5fff5da.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/ios-landscape.png
// module id = CNxV
// module chunks = 50